import { homeRoute, forgotPasswordRoute } from './../../core/routing/route-names';
import { AuthService } from '../services/auth.service';
import { OnInit, Component, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule, FormControl } from '@angular/forms';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToastService } from '../services/toast.service';
import { LoginModel } from '../shared/login.model';
import { SpinnerService } from '../spinner/spinner.service';
import { TranslatePipe } from '@ngx-translate/core';
import { TenantThemeService } from '../services/tenant-theme.service';
import { ThemeService } from '../services/theme.service';

import { PasswordInputComponent } from '../shared/password-input/password-input.component';
import { AppErrorMessagesComponent } from '../error-messages/app-error-messages.component';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, PasswordInputComponent, RouterLink, TranslatePipe, AsyncPipe]
})
export class LoginComponent implements OnInit {
  public loading = false;
  public loginModel: LoginModel = {} as LoginModel;

  public loginForm!: UntypedFormGroup;
  public loginUserNameControl!: UntypedFormControl;
  public loginPasswordControl!: UntypedFormControl;
  public forgotPasswordRoute = forgotPasswordRoute;

  public readonly logoUrl$ = combineLatest([this.themeService.logoUrl$, this.themeService.mode$]).pipe(
    map(([logoUrl, mode]) => logoUrl || this.themeService.getDefaultLogoUrl(mode))
  );

  private initFlag: any | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private toastService: ToastService,
    private spinnerService: SpinnerService,
    private tenantThemeService: TenantThemeService,
    private themeService: ThemeService) { }

  ngOnInit() {
    this.spinnerService.reset();
    this.initFlag = this.route.snapshot.queryParams.init;
    this.initializeForm();
    if (this.authService.isUserLoggedIn() && !this.initFlag) {
      this.router.navigate([homeRoute]);
    }
  }

  public login(): void {
    this.loading = true;

    this.loginModel.username = this.loginForm.value.userName;
    this.loginModel.password = this.loginForm.value.password;
    this.authService.login(this.loginModel).subscribe({
      next: (result) => {
        this.loading = false;

        if (result) {
          this.tenantThemeService.initializeForUser(this.authService.getUserInfo()).subscribe();
          if (this.authService.redirectUrl) {
            this.router.navigateByUrl(this.authService.redirectUrl);
          } else {
            this.router.navigate([homeRoute]);
          }
        }
      },
      error: error => {
        this.loading = false;
        this.toastService.showApiException(error, 'i18n.core.messages.login.title', 'i18n.core.messages.login.message');
      }}
    );
  }

  private initializeForm(): void {
    this.loginUserNameControl = new FormControl(null, [Validators.required]);
    this.loginPasswordControl = new FormControl(null, [Validators.required]);
    this.loginForm = new UntypedFormGroup({
      userName: this.loginUserNameControl,
      password: this.loginPasswordControl
    });
  }
}
